import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Interface para tipado
 */
export interface EstadoPlanAccion {
  id?: number;
  descripcion: string;
  estado?: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

@Injectable({
  providedIn: "root",
})
export class EstadoPlanAccionService {
  private apiUrl = `${environment.apiUrl}/api/estado-plan-accion`;

  constructor(private http: HttpClient) {}

  // Listar todos
  getEstados(): Observable<EstadoPlanAccion[]> {
    return this.http
      .get<EstadoPlanAccion[]>(this.apiUrl, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Obtener por ID
  getEstadoById(id: number | string): Observable<EstadoPlanAccion> {
    return this.http
      .get<EstadoPlanAccion>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Crear
  createEstado(payload: EstadoPlanAccion): Observable<EstadoPlanAccion> {
    return this.http
      .post<EstadoPlanAccion>(this.apiUrl, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Actualizar
  updateEstado(id: number | string, payload: EstadoPlanAccion): Observable<EstadoPlanAccion> {
    return this.http
      .put<EstadoPlanAccion>(`${this.apiUrl}/${id}`, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Eliminar
  deleteEstado(id: number | string): Observable<any> {
    return this.http
      .delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Activar
  activar(id: number | string): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Inactivar
  inactivar(id: number | string): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }
}
